"use client";
import { StaticImageData } from "next/image";

import { ArrowRight } from "lucide-react";
import ImageComponent from "@/components/ui/image";
import styles from "./MobileOccasionGifts.module.css";
import { cn } from "@/utils/utils";
import Link from "next/link";
import { sendGAEvent } from "@next/third-parties/google";

import BirthdayImg from "@/assets/images/v2/birthday_occ.webp";
import WeddingImg from "@/assets/images/v2/wedding_occ.webp";
import HousewarmingImg from "@/assets/images/v2/housewarming_occ.webp";

const occasions = [
  {
    title: "Birthday",
    image: BirthdayImg,
    slug: "birthday-gifts",
    id: 27,
  },
  {
    title: "Wedding",
    image: WeddingImg,
    slug: "wedding-gifts",
    id: 16,
  },
  {
    title: "Housewarming",
    image: HousewarmingImg,
    slug: "housewarming",
    id: 28,
  },
];

const OccasionCard = ({
  title,
  image,
  slug,
  id,
}: {
  title: string;
  image: StaticImageData | string;
  slug: string;
  id: number;
}) => (
  <Link
    href={`/listing/${slug}?id=${id}`}
    className={cn(styles.cardContainer, "group")}
    onClick={() => {
      const formattedName = title.toLowerCase().replace(/ /g, "_");
      sendGAEvent("event", `show_more_${formattedName}_clicked`);
    }}
  >
    <ImageComponent
      alt={`${title} Collection`}
      src={image}
      fill
      className={styles.cardImage}
    />
    <div className={styles.cardOverlay}></div>
    <div className={styles.cardContent}>
      <div>
        <span className={styles.cardLabel}>Collection</span>
        <div className="flex items-center gap-3">
          <h4 className={styles.cardTitle}>{title}</h4>
          <ArrowRight
            className="size-7 text-v2-surface-container-lowest transition-transform duration-300 group-hover:translate-x-1 mt-1"
            strokeWidth={2}
          />
        </div>
      </div>
    </div>
  </Link>
);

const MobileOccasionGifts = () => {
  return (
    <section className={styles.sectionContainer} id="collections">
      <header className="text-center max-w-3xl mb-12 md:mb-16 mx-auto">
        <span className="font-outfit uppercase tracking-[0.3em] text-v2-tertiary text-[10px] font-bold block">
          Personal Curation
        </span>
        <h2 className="text-center font-lora text-v2-primary mb-2 md:mb-4 text-2xl md:text-4xl lg:text-5xl italic md:not-italic font-extralight md:font-semibold leading-8 md:leading-[1.25] lg:leading-none">
          <span
            className={cn(
              "tracking-tight md:tracking-normal not-italic md:italic font-bold md:font-normal",
              "md:hidden",
            )}
          >
            Special Occasions
          </span>
          <span className="hidden md:inline">
            <span className="tracking-tight md:tracking-normal not-italic md:italic font-bold md:font-normal">
              Special
            </span>{" "}
            Moments
          </span>
        </h2>
        <p className="font-outfit font-normal text-sm text-v2-on-surface-variant/80 uppercase tracking-widest mt-2">
          The most meaningful gifts India makes
        </p>
      </header>
      <div className={styles.gridContainer}>
        {occasions.map((occ, idx) => (
          <OccasionCard key={idx} {...occ} />
        ))}
      </div>
    </section>
  );
};

export default MobileOccasionGifts;
